import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface Props {
  children: ReactNode;
}

/**
 * Guard ktorý zabráni neovereným userom dostať sa do app.
 * Ak user existuje v localStorage ale email_verified === false → redirect na /verify-email.
 * Default true (chýbajúce pole) = predpokladáme overený (kompatibilita so starými ulozenymi user objektmi).
 */
export function RequireVerifiedEmail({ children }: Props) {
  const stored = localStorage.getItem('user');
  if (!stored) return <>{children}</>; // nie je prihlásený — necháme inú logiku (page sama presmeruje)

  try {
    const u = JSON.parse(stored);
    if (u.email_verified === false) {
      return <Navigate to={`/verify-email?email=${encodeURIComponent(u.email || '')}&from=login`} replace />;
    }
  } catch {
    // poškodený JSON — necháme prejsť, page si poradí
  }

  return <>{children}</>;
}
